import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f0aca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "createTime"
}
const _hoisted_3 = { class: "box mark" }
const _hoisted_4 = { class: "report-card" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "battle-group-title battle-group-title--primary battle-group-title--bracket" }, " <总量数据> ", -1))
const _hoisted_6 = { class: "section summary-section" }
const _hoisted_7 = { class: "report-table report-table--target" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "激活量目标", -1))
const _hoisted_9 = { class: "col-value" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "活跃站点目标", -1))
const _hoisted_11 = { class: "col-value" }
const _hoisted_12 = { class: "section" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "battle-group-title battle-group-title--sub" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "star" }, "*"),
  /*#__PURE__*/_createTextVNode("当日数据 ")
], -1))
const _hoisted_14 = {
  key: 0,
  class: "report-table"
}
const _hoisted_15 = { class: "col-name" }
const _hoisted_16 = { class: "section" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "battle-group-title battle-group-title--sub" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "star" }, "*"),
  /*#__PURE__*/_createTextVNode("本月数据"),
  /*#__PURE__*/_createElementVNode("span", { class: "battle-group-title__note" }, "（当月1日 至 昨日）")
], -1))
const _hoisted_18 = {
  key: 0,
  class: "report-table"
}
const _hoisted_19 = { class: "col-name" }
const _hoisted_20 = {
  key: 0,
  class: "space"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "battle-group-title battle-group-title--primary battle-group-title--bracket battle-group-title--team" }, " <战队数据> ", -1))
const _hoisted_22 = { class: "section" }
const _hoisted_23 = {
  key: 1,
  class: "area-list"
}
const _hoisted_24 = { class: "area-item-header" }
const _hoisted_25 = { class: "groupLeader" }
const _hoisted_26 = {
  key: 0,
  class: "target"
}
const _hoisted_27 = {
  key: 1,
  style: {"margin-left":"0.4rem"}
}
const _hoisted_28 = { class: "target" }
const _hoisted_29 = { class: "target" }
const _hoisted_30 = { class: "section sub-section" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "battle-group-title battle-group-title--sub" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "star" }, "*"),
  /*#__PURE__*/_createTextVNode("当日数据 ")
], -1))
const _hoisted_32 = { class: "report-table" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "当日订单总量", -1))
const _hoisted_34 = { class: "col-value" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "当日下单成功量", -1))
const _hoisted_36 = { class: "col-value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "当日激活量", -1))
const _hoisted_38 = { class: "col-value col-highlight" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "当日新增活跃站点", -1))
const _hoisted_41 = { class: "col-value col-highlight" }
const _hoisted_42 = { class: "section sub-section" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "battle-group-title battle-group-title--sub" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "star" }, "*"),
  /*#__PURE__*/_createTextVNode("本月数据 ")
], -1))
const _hoisted_44 = { class: "report-table" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "本月订单总量", -1))
const _hoisted_46 = { class: "col-value" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "本月下单成功量", -1))
const _hoisted_48 = { class: "col-value" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "本月实际激活量", -1))
const _hoisted_50 = { class: "col-value col-highlight" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "本月累计激活量达成进度", -1))
const _hoisted_53 = { class: "col-value" }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "col-name" }, "本月累计活跃站点达成进度", -1))
const _hoisted_56 = { class: "col-value" }
const _hoisted_57 = {
  key: 0,
  class: "space"
}

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { formatPercentage, formatThousands } from "@/utils";
import { Overlay, Loading, Empty, showFailToast } from "vant";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";
import request from "@/provide/fetch";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'VerticalMarket331peakBattle',
  props: {
  /** 嵌入 VerticalMarket 等父页时：不占满屏、隐藏重复「生成时间」 */
  embedded: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props



const BATTLE_GROUP_TOTAL_URL = "/api/wx/cs/battle-group-total";
const LIST_BATTLE_GROUP_DETAIL_URL = "/api/wx/cs/list-battle-group-detail";

const route = useRoute();
/** 嵌入父页：不挡全屏 loading，内容区先展示，后台拉数 */
const visible = ref(props.embedded);
const hasTotalData = ref(false);
const pageData = ref<{
  activeTarget?: string | number;
  activeStationTarget?: string | number;
  dayList?: any[];
  monthList?: any[];
}>({
  activeTarget: "",
  activeStationTarget: "",
  dayList: [],
  monthList: [],
});
const areaList = ref<any[]>([]);
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");

/** 总量数据 - 当日/本月表格展示名（按行序；接口 name 作别名兜底） */
const BATTLE_TOTAL_DAY_LABELS = [
  "订单总量",
  "下单成功量",
  "实际激活量",
  "新增活跃站点",
];

const BATTLE_TOTAL_MONTH_LABELS = [
  ...BATTLE_TOTAL_DAY_LABELS,
  "本月累计激活量达成度",
  "本月累计活跃站点达成度",
  "本月时间进度",
];

const BATTLE_TOTAL_DAY_NAME_MAP: Record<string, string> = {
  当日订单总量: "订单总量",
  订单总量: "订单总量",
  当日下单成功量: "下单成功量",
  下单成功量: "下单成功量",
  当日实际激活量: "实际激活量",
  当日激活量: "实际激活量",
  实际激活量: "实际激活量",
  当日新增活跃站点: "新增活跃站点",
  新增活跃站点: "新增活跃站点",
};

const BATTLE_TOTAL_MONTH_NAME_MAP: Record<string, string> = {
  本月订单总量: "订单总量",
  订单总量: "订单总量",
  本月下单成功量: "下单成功量",
  下单成功量: "下单成功量",
  本月实际激活量: "实际激活量",
  实际激活量: "实际激活量",
  本月累计活跃站点: "新增活跃站点",
  本月新增活跃站点: "新增活跃站点",
  新增活跃站点: "新增活跃站点",
  本月累计激活量达成进度: "本月累计激活量达成度",
  本月累计激活量达成度: "本月累计激活量达成度",
  本月累计活跃站点达成进度: "本月累计活跃站点达成度",
  本月累计活跃站点达成度: "本月累计活跃站点达成度",
  本月时间进度: "本月时间进度",
};

const battleTotalRowLabel = (
  section: "day" | "month",
  index: number,
  apiName: string
): string => {
  const order =
    section === "day" ? BATTLE_TOTAL_DAY_LABELS : BATTLE_TOTAL_MONTH_LABELS;
  const map =
    section === "day" ? BATTLE_TOTAL_DAY_NAME_MAP : BATTLE_TOTAL_MONTH_NAME_MAP;
  const key = (apiName ?? "").trim();
  if (key && map[key]) return map[key];
  if (index >= 0 && index < order.length) return order[index];
  return key;
};

const isBattleTotalValueHighlight = (
  section: "day" | "month",
  index: number,
  item: { name?: string; type?: string }
): boolean => {
  const label = battleTotalRowLabel(section, index, item?.name ?? "");
  return label === "实际激活量" || label === "新增活跃站点";
};
let initPromise: Promise<void> | null = null;

const getPageData = async () => {
  try {
    const res = await request({
      url: BATTLE_GROUP_TOTAL_URL,
      method: "POST",
      data: { startDay: time, endDay: time },
      headers: { openId: sessionStorage.getItem("openid") },
      skipAuthRedirect: props.embedded,
    });
    if (props.embedded && res?.code === 401) {
      return;
    }
    if (!props.embedded) {
      visible.value = true;
    }
    if (res?.code === 200 && res?.data != null) {
      hasTotalData.value = true;
      const d = res.data as any;
      pageData.value = {
        activeTarget: d.activeTarget ?? "",
        activeStationTarget: d.activeStationTarget ?? "",
        dayList: Array.isArray(d.dayList) ? d.dayList : [],
        monthList: Array.isArray(d.monthList) ? d.monthList : [],
      };
    } else if (res?.data == null) {
      // res.data === null 为正常情况，不展示总量模块，不弹提示
    } else if (!props.embedded) {
      const msg =
        typeof res?.data === "string"
          ? res.data
          : res?.message ?? "加载失败，请稍后重试";
      showFailToast(msg);
    }
  } catch (_e) {
    if (!props.embedded) {
      visible.value = true;
      showFailToast("加载失败，请稍后重试");
    }
  }
};

const getAreaList = async () => {
  try {
    const res = await request({
      url: LIST_BATTLE_GROUP_DETAIL_URL,
      method: "POST",
      data: { startDay: time, endDay: time },
      headers: { openId: sessionStorage.getItem("openid") },
      skipAuthRedirect: props.embedded,
    });
    if (props.embedded && res?.code === 401) {
      areaList.value = [];
      return;
    }
    if (res?.code === 200 && res?.data != null) {
      areaList.value = Array.isArray(res.data) ? res.data : [];
    } else if (res?.data == null) {
      // res.data === null 为正常情况，不展示战队列表，不弹提示
    } else if (!props.embedded) {
      const msg =
        typeof res?.data === "string"
          ? res.data
          : res?.message ?? "加载失败，请稍后重试";
      showFailToast(msg);
    }
  } catch (_e) {
    areaList.value = [];
    if (!props.embedded) {
      showFailToast("加载失败，请稍后重试");
    }
  }
};

const initBattleData = () => {
  if (!initPromise) {
    initPromise = Promise.all([getPageData(), getAreaList()]).then(() => undefined);
  }
  return initPromise;
};

initBattleData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrap", { 'wrap--embedded': __props.embedded }])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (!__props.embedded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 生成时间：" + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (hasTotalData.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_8,
                        _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(formatThousands)(pageData.value.activeTarget || 0)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_10,
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatThousands)(pageData.value.activeStationTarget || 0)), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  ((pageData.value.dayList?.length ?? 0) > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.dayList ?? [], (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_15, _toDisplayString(battleTotalRowLabel(
                          "day",
                          index,
                          item?.name ?? ""
                        )), 1),
                              _createElementVNode("td", {
                                class: _normalizeClass(["col-value", {
                        'col-highlight': isBattleTotalValueHighlight(
                          'day',
                          index,
                          item
                        ),
                      }])
                              }, _toDisplayString(item?.type === "percentage"
                          ? _unref(formatPercentage)(item?.value ?? 0)
                          : _unref(formatThousands)(item?.value ?? 0)), 3)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock(_unref(Empty), {
                        key: 1,
                        description: "暂无数据",
                        "image-size": "80"
                      }))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  ((pageData.value.monthList?.length ?? 0) > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.monthList ?? [], (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_19, _toDisplayString(battleTotalRowLabel(
                          "month",
                          index,
                          item?.name ?? ""
                        )), 1),
                              _createElementVNode("td", {
                                class: _normalizeClass(["col-value", {
                        'col-highlight': isBattleTotalValueHighlight(
                          'month',
                          index,
                          item
                        ),
                      }])
                              }, _toDisplayString(item?.type === "percentage"
                          ? _unref(formatPercentage)(item?.value ?? 0)
                          : _unref(formatThousands)(item?.value ?? 0)), 3)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock(_unref(Empty), {
                        key: 1,
                        description: "暂无数据",
                        "image-size": "80"
                      }))
                ]),
                (hasTotalData.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            (!areaList.value.length)
              ? (_openBlock(), _createBlock(_unref(Empty), {
                  key: 0,
                  description: "暂无数据",
                  "image-size": "80"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "area-item"
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      'rank-badge',
                      {
                        one: index === 0,
                        two: index === 1,
                        three: index === 2,
                        other: index > 2,
                      },
                    ])
                        }, _toDisplayString(index + 1), 3),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(item?.groupLeader ?? ""), 1),
                        (!!item?.targetActiveCount)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (!item?.targetActiveShopCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "目标：" + _toDisplayString(_unref(formatThousands)(item.targetActiveCount)), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("span", _hoisted_28, "激活目标：" + _toDisplayString(_unref(formatThousands)(item.targetActiveCount)), 1),
                                    _createElementVNode("span", _hoisted_29, "活跃站点目标：" + _toDisplayString(_unref(formatThousands)(item.targetActiveShopCount)), 1)
                                  ]))
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("table", _hoisted_32, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_33,
                              _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(formatThousands)(item?.orderCount ?? 0)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_35,
                              _createElementVNode("td", _hoisted_36, _toDisplayString(_unref(formatThousands)(item?.orderSuccessCount ?? 0)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_37,
                              _createElementVNode("td", _hoisted_38, _toDisplayString(_unref(formatThousands)(item?.activeCount ?? 0)), 1)
                            ]),
                            (!!item?.targetActiveShopCount)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                                  _hoisted_40,
                                  _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(formatThousands)(item?.newActiveShopCount ?? 0)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("table", _hoisted_44, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_45,
                              _createElementVNode("td", _hoisted_46, _toDisplayString(_unref(formatThousands)(item?.monthOrderCount ?? 0)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_47,
                              _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(formatThousands)(item?.monthOrderSuccessCount ?? 0)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_49,
                              _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(formatThousands)(item?.monthActiveCount ?? 0)), 1)
                            ]),
                            (!!item?.targetActiveCount)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                                  _hoisted_52,
                                  _createElementVNode("td", _hoisted_53, _toDisplayString(item?.activeTargetRate ?? 0), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (!!item?.targetActiveShopCount)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                                  _hoisted_55,
                                  _createElementVNode("td", _hoisted_56, _toDisplayString(item?.activeShopTargetRate ?? 0), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
          ])
        ]),
        (!__props.embedded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_57))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    (!__props.embedded)
      ? (_openBlock(), _createBlock(_unref(Overlay), {
          key: 0,
          class: "overlay",
          show: !visible.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Loading), { type: "spinner" })
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})